import script from "./Json2Table.vue?vue&type=script&setup=true&lang=ts"
export * from "./Json2Table.vue?vue&type=script&setup=true&lang=ts"

import "./Json2Table.vue?vue&type=style&index=0&id=5171c9e6&lang=css"

const __exports__ = script;

export default __exports__